<div class="signature-approval-list">
  @for (policy of signaturePolicies; track policy.id) {
  <div class="approval-group" [class.completed]="isGroupComplete(policy)">
    <div class="approval-header">
      <div class="approval-type">
        <mat-icon>{{ isGroupComplete(policy) ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
        <h3>{{ policy.signatureTypeLang }}</h3>
      </div>
      @if (getRequiredCount(policy) > 1) {
      <div class="approval-count">{{ getSignatureCount(policy.id) }} / {{ getRequiredCount(policy) }}</div>
      }
    </div>

    @if (isGroupComplete(policy)) {
    <div class="approval-status completed">
      <mat-icon>done</mat-icon>
      <span>{{ 'Annex.SignatureCompleted' | translate }}</span>
    </div>
    } @else {
    <div class="approval-status pending">
      <mat-icon>schedule</mat-icon>
      <span>{{ 'Annex.SignaturePending' | translate }}</span>
    </div>
    }
  </div>
  }
</div>
